import React from 'react';

import './TooltipContentBlocks.theme.scss';

const TooltipContentBlocks = () =>
  <div className="rs-tooltip-big__content tooltip-content-blocks">
    <div>Building Blocks to Target Compound</div>
    <div>The "Building Blocks to target" column shows building blocks/starting materials required to synthesize the given target compound, and number of steps in each route. You may:</div>
    <ul className="info-tooltip-content-list">
      <li className="info-tooltip-content-list-item bullet-dot">Zoom into/enlarge structures by clicking the magnifier icon below a structure</li>
      <li className="info-tooltip-content-list-item bullet-dot">View substance availability and pricing information by clicking the shopping cart icon</li>
      <li className="info-tooltip-content-list-item bullet-dot">Create retrosynthesis plan for a compound, view details available for the compound, copy structure for a query in Reaxys by clicking the "..."</li>
    </ul>
  </div>;

export default TooltipContentBlocks;
